import type { Theme } from '@mui/material/styles'
import type { SystemStyleObject } from '@mui/system'
import { TABLE_HEAD_BG } from './tableListTokens'

/**
 * Chiều rộng cột thao tác (icon): slot × số nút.
 * Slot đủ cho icon 26px + gap; header «Thao tác» vừa 2 nút (~72px).
 * VD: 2 → 72px, 3 → 108px.
 */
export const TABLE_ACTION_ICON_SLOT_PX = 36

export function tableActionsColWidthPx(iconCount: number): number {
  return Math.max(1, Math.floor(iconCount)) * TABLE_ACTION_ICON_SLOT_PX
}

export function tableActionsColDims(iconCount: number): { width: string; minWidth: string; maxWidth: string } {
  const px = tableActionsColWidthPx(iconCount)
  const s = `${px}px`
  return { width: s, minWidth: s, maxWidth: s }
}

const actionIconNested = {
  '& .MuiIconButton-root': {
    width: 26,
    height: 26,
    padding: '3px',
  },
} as const

/** Ô cột thao tác: width cố định + icon gọn để vừa ô. */
export function tableActionsCellSx(iconCount: number): SystemStyleObject<Theme> {
  return {
    ...tableActionsColDims(iconCount),
    textAlign: 'center',
    boxSizing: 'border-box',
    verticalAlign: 'middle',
    px: '4px',
    whiteSpace: 'nowrap',
    ...actionIconNested,
  }
}

/** Sticky cột thao tác (header). Nền gutter scrollbar do `tableListScrollMainSx` sơn — không ::after tràn phải (tránh scroll ngang giả). */
export function tableActionsStickyHeadSx(theme: Theme): SystemStyleObject<Theme> {
  return {
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      right: 0,
      zIndex: 11,
      backgroundColor: `${TABLE_HEAD_BG} !important`,
      boxShadow: '-10px 0 16px -8px rgba(0,0,0,0.07)',
    },
  }
}

/** Ô cột thao tác sticky từ breakpoint md (giống lưới sản phẩm). Nền dòng do TableRow + TableList — không set background ở đây để tránh !important cạnh tranh hover/zebra. */
export function tableActionsStickyCellSx(theme: Theme, iconCount: number, _cellBg: string): SystemStyleObject<Theme> {
  return {
    ...tableActionsColDims(iconCount),
    textAlign: 'center',
    boxSizing: 'border-box',
    verticalAlign: 'middle',
    px: '4px',
    whiteSpace: 'nowrap',
    ...actionIconNested,
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      right: 0,
      zIndex: 2,
      boxShadow: '-10px 0 16px -8px rgba(0,0,0,0.07)',
    },
  }
}
